function parseDatePortion(value: string): Date | null {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value.trim());
    if (!match) {
        return null;
    }
    const year = Number(match[1]);
    const monthIndex = Number(match[2]) - 1;
    const day = Number(match[3]);
    if (
        !Number.isInteger(year) ||
        !Number.isInteger(monthIndex) ||
        !Number.isInteger(day) ||
        monthIndex < 0 ||
        monthIndex > 11 ||
        day < 1 ||
        day > 31
    ) {
        return null;
    }
    return new Date(year, monthIndex, day);
}

export function formatInclusiveDate(value: string | null | undefined): string {
    if (!value) {
        return 'Open';
    }
    const parsed = parseDatePortion(value);
    return parsed ? parsed.toLocaleDateString() : value;
}

export function formatInclusiveDateRange(
    start: string | null | undefined,
    end: string | null | undefined,
): string | null {
    if (!start || !end) {
        return null;
    }
    return `${formatInclusiveDate(start)} - ${formatInclusiveDate(end)}`;
}
